import { useState } from 'react';
import { FlightCard } from '../components/FlightCard';
import { useAircraftTypes } from '../hooks/use-aircraft';
import { useFlights } from '../hooks/use-flights';

export function FlightListPage() {
  const [aircraftTypeId, setAircraftTypeId] = useState<string>('');
  const types = useAircraftTypes();
  const flights = useFlights({
    aircraftTypeId: aircraftTypeId || undefined,
    onlyAvailable: true,
  });

  return (
    <div className="px-4 py-4 space-y-3">
      <header className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Verfügbare Flüge</h1>
        <button
          onClick={() => flights.refetch()}
          className="text-xs rounded-md border border-slate-700 bg-slate-800 px-2 py-1 hover:bg-slate-700"
          disabled={flights.isFetching}
        >
          {flights.isFetching ? '⟳' : '↻'} Aktualisieren
        </button>
      </header>

      <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-3">
        <label className="block text-xs font-medium text-slate-400">
          Flugzeugtyp
        </label>
        <select
          value={aircraftTypeId}
          onChange={(e) => setAircraftTypeId(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm"
        >
          <option value="">Alle Typen</option>
          {types.data?.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
      </div>

      {flights.isLoading ? (
        <p className="py-12 text-center text-sm text-slate-400">Lädt …</p>
      ) : flights.error ? (
        <p className="py-12 text-center text-sm text-rose-400">
          Fehler beim Laden
        </p>
      ) : flights.data && flights.data.length > 0 ? (
        <div className="space-y-3">
          {flights.data.map((o) => (
            <FlightCard key={o.id} offer={o} />
          ))}
        </div>
      ) : (
        <p className="py-12 text-center text-sm text-slate-400">
          Aktuell keine Flüge verfügbar.
        </p>
      )}
    </div>
  );
}
